import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';

import * as ProofOfDeliveryActions from './proof-of-delivery.actions';
import * as ProofOfDeliverySelectors from './proof-of-delivery.selectors';
import {Portals} from '@qwyk/models';

@Injectable()
export class ProofOfDeliveryFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loaded$ = this.store.pipe(
        select(ProofOfDeliverySelectors.getProofOfDeliveryLoaded)
    );
    getProofDelivery$ = this.store.pipe(
        select(ProofOfDeliverySelectors.getProofOfDelivery)
    );
    hasOne = this.store.pipe(
        select(ProofOfDeliverySelectors.hasOne)
    );

    constructor(private readonly store: Store) {
    }

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    public init(parent: Portals.ParentEntity): void {
        this.store.dispatch(ProofOfDeliveryActions.init({parent}));
    }
}
